import { Component, Input, OnInit } from '@angular/core';
import { PayPeriod } from 'projects/app-misc/src/app/modules/punch-time-widget/data/pay-period';

@Component({
  selector: 'app-additional-report-header',
  templateUrl: './additional-report-header.component.html',
  styleUrls: ['./additional-report-header.component.scss']
})
export class AdditionalReportHeaderComponent implements OnInit {

  @Input()
  payPeriod: PayPeriod;

  constructor() {
  }

  ngOnInit(): void {
  }

}
